import { Fragment } from 'react';
import { Grid, FormLabel as MuiFormLabel } from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';
import { pieTaxRates } from '../../common/types';
import { Colors, DialogBox, SubtitleText } from '../controls/helpers';

const CalculateTaxRateDialog = ({ ok, open }: { ok: () => void; open: boolean; }) =>
    <DialogBox ok={ok} open={open} icon={<HelpIcon htmlColor={Colors.Green} />}>
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <SubtitleText hideMarginBottom>
                    To select your correct PIR you need to calculate your taxable income (which includes your worldwide income and may include income when you were not a resident in New Zealand) and PIE income for each of the previous two income years (an income year is the period from 1 April in one year to 31 March the next year). The PIR applying to you is then determined based on the year which has the lower combined income amount. The PIRs currently applicable and the income levels they apply to are:
                </SubtitleText>
            </Grid>
            <Grid item xs={12}>
                {pieTaxRates.map((pieTaxRate, index) =>
                    <Fragment key={index}>
                        {index !== 0 && <br />}
                        <SubtitleText black hideMarginBottom>
                            <b>{pieTaxRate.label}</b>
                        </SubtitleText>
                        {pieTaxRate.incomeBrackets.map((incomeBracket, i) =>
                            <Fragment key={i}>
                                {i === 2 &&
                                    <Grid container justifyContent="space-between">
                                        <Grid item>
                                            <MuiFormLabel style={{ fontSize: '0.875rem' }}>or</MuiFormLabel>
                                        </Grid>
                                    </Grid>
                                }
                                <Grid container justifyContent="space-between">
                                    <Grid item sm={8} xs={6}>
                                        <MuiFormLabel style={{ fontSize: '0.875rem' }}>{incomeBracket}</MuiFormLabel>
                                    </Grid>
                                    <Grid item sm={4} xs={6}>
                                        <MuiFormLabel style={{ fontSize: '0.875rem' }}>Taxable {i % 2 !== 0 && '+ PIE '}Income</MuiFormLabel>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        )}
                    </Fragment>
                )}
            </Grid>
        </Grid>
    </DialogBox>

export default CalculateTaxRateDialog;
